module.exports = __webpack_public_path__ + "icon_toolsblocks_right.b205a54edb03740b8afd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_toolsblocks_right.svg
// module id = ./src/assets/img/icon_toolsblocks_right.svg
// module chunks = main